import React from "react";
import { useTranslation } from "react-i18next";
import closeButton from "@/images/icons/close-modal-button.svg";

interface StudentListModalHeaderProps {
  onCloseHandler: () => void;
}

export const StudentListModalHeader = ({ onCloseHandler }: StudentListModalHeaderProps) => {
  const { t } = useTranslation("assessment_modal");
  return (
    <div className="student-list-modal-header">
      <h2 className="student-list-modal-header-title">{t("student_list")}</h2>
      <button className="student-list-modal-header-close" onClick={onCloseHandler} data-testid="close-button">
        <img src={closeButton} alt="close" />
      </button>
    </div>
  );
};
